// Da Vinci State Store (Proxy Pattern)
import { DaVinciEvents } from "./DaVinciEvents.js";

const DEFAULT_STATE = {
    seriesId: null,
    episodeId: null,
    title: '무제 (Untitled)', // Episode Title
    blocks: [], // { id, type, content, ... }
    metadata: {
        // Episode metadata (thumbnail usually at series level, but episodes might have one)
    },
    ui: {
        isSettingsOpen: false,
        isInitialized: false,
        isSaving: false
    }
};

let stateProxy = null;

export const DaVinciState = {
    init(initialData = {}) {
        const rawState = { ...DEFAULT_STATE, ...initialData };
        if (initialData.metadata) {
            rawState.metadata = { ...DEFAULT_STATE.metadata, ...initialData.metadata };
        }
        if (initialData.ui) {
            rawState.ui = { ...DEFAULT_STATE.ui, ...initialData.ui };
        }

        // Deep Proxy for nested updates (simplified for 1-level depth mostly)
        const handler = {
            set(target, prop, value) {
                target[prop] = value;
                DaVinciEvents.emit(DaVinciEvents.ON_STATE_CHANGE, { prop, value, state: target });
                return true;
            }
        };

        stateProxy = new Proxy(rawState, handler);
        return stateProxy;
    },

    get() {
        return stateProxy || this.init(); // Auto-init if accessed early
    },

    // Actions
    setTitle(title) {
        this.get().title = title;
    },

    addBlock(type) {
        const id = 'blk_' + Date.now();
        const newBlock = { id, type, content: '', url: null };
        const s = this.get();
        // Proxy doesn't detect array push automatically unless we wrap array or re-assign
        s.blocks = [...s.blocks, newBlock];
        DaVinciEvents.emit(DaVinciEvents.ON_BLOCK_ADD, newBlock);
    },

    deleteBlock(id) {
        const s = this.get();
        s.blocks = s.blocks.filter(b => b.id !== id);
        DaVinciEvents.emit(DaVinciEvents.ON_BLOCK_DELETE, id);
    },

    updateBlock(id, updates) {
        const s = this.get();
        const blk = s.blocks.find(b => b.id === id);
        if (blk) {
            // If updates is string, treat as content (legacy compat)
            if (typeof updates === 'string') {
                blk.content = updates;
            } else {
                Object.assign(blk, updates);
            }
            DaVinciEvents.emit(DaVinciEvents.ON_BLOCK_UPDATE, { id });
        }
    },

    setBlocks(newBlocks) {
        this.get().blocks = newBlocks;
    },

    toggleSettings(isOpen) {
        const s = this.get();
        s.ui = { ...s.ui, isSettingsOpen: isOpen };
    }
};
